"use client";
import { jsx as e } from "react/jsx-runtime";
import { memo as c } from "react";
import l from "../components/Icon/SvgIcon.js";
const t = (o) => /* @__PURE__ */ e(
  l,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ e(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.126 4c1.3 0 2.627.321 3.836.926a.656.656 0 1 1-.588 1.176 7.3 7.3 0 0 0-3.248-.785c-3.283 0-6.08 2.326-6.773 5.558h1.404c.482 0 .742.52.519.928l-2.078 3.415c-.26.371-.816.371-1.04 0l-2.077-3.415c-.223-.408.037-.928.52-.928h1.394C4.712 6.889 8.124 4 12.125 4m7.715 4.743 2.078 3.415c.223.409-.037.928-.52.928h-1.394c-.717 3.987-4.13 6.876-8.131 6.876a8.6 8.6 0 0 1-3.836-.927.656.656 0 0 1-.294-.881.654.654 0 0 1 .882-.294 7.3 7.3 0 0 0 3.248.785c3.283 0 6.079-2.326 6.774-5.558h-1.405c-.482 0-.742-.52-.52-.928l2.079-3.416c.26-.37.816-.37 1.039 0",
        clipRule: "evenodd"
      }
    )
  }
), h = c(t);
export {
  h as Renew,
  h as default
};
